import { GIFTS_GET_SELECTED_DESTINATION_ORIGINS, GIFTS_GET_SELECTED_DESTINATION } from "../../store/gifts/getter-types";
import { SET_GIFTS_STATE } from "../../store/gifts/mutation-types";
import prependCustomIcons from "../../utils/mixins/prependCustomIcons";
import replaceArrows from "../../utils/mixins/replaceArrows";

export default {
  mixins: [prependCustomIcons, replaceArrows],
  props: {
    destination: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      form: {
        passengers: this.$store.state.gifts.passengers,
        origin_id: this.$store.state.gifts.origin_id
      }
    }
  },
  computed: {
    origins() {
      return this.$store.getters[GIFTS_GET_SELECTED_DESTINATION_ORIGINS];
    },
    origin_id() {
      return this.$store.state.gifts.origin_id;
    },
    personsItems() {
      let options = [];

      for (let i = 1; i <= 10; i++) {
        options.push({
          text: i + " " + this.$tc('shared.person', i),
          value: i,
        });
      }
      return options;
    },
  },
  methods: {
    next() {
      const { slug } = this.$store.getters[GIFTS_GET_SELECTED_DESTINATION];
      const route = `/regala/${slug}/datos`;
      this.$router.push(route);
    }
  },
  watch: {
    origin_id(origin_id) {
      this.form.origin_id = origin_id;
    },
    form: {
      deep: true,
      handler(form) {
        this.$store.commit(SET_GIFTS_STATE, [
          {
            prop: "origin_id",
            value: form.origin_id
          },
          {
            prop: "passengers",
            value: form.passengers
          }
        ]);
      }
    }
  }
};
